import { ErrorResponse, GlobalStatus, GlobalVariableValues, MessageParameters, MessageRequest, PackingSupplierStatusEnum, SaleOrderStatusEnum, SoStatusEnum, StatusEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, LessThan, Not, Raw, Repository } from 'typeorm';
import { PurchaseOrderIdRequest } from '../po-creation/dto/po-id.request';
import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, TaxesService, UnitcodeService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters'

import { AsnAdapter } from './dto/asn.adapter';
import { AsnItems } from './asn-items.entity';
import { Asn } from './asn.entity';
import { AsnRepository } from './repository/asn-repository';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { PoItems } from '../po-creation/po-creation-items.entity';

import appSettings from 'apps/services/config';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { whatsApp } from '../../../../whatsapp';
import { AsnDto } from './dto/asn.dto';
import { PoCreation } from '../po-creation/po-creation.entity';
import { VenndorIdReq } from '../po-creation/dto/vendor-id-req';
import { AsnIdReq } from './dto/asn-id-req';
import { InvoiceCreateDto } from './dto/invoice-create-dto';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { BroadCastMessageRequest, WhatsAppLogDto } from "@gtpl/shared-models/whatsapp-broad-cast";
import { PaymentCreateDto } from './dto/payment-create-dto';
import { Grn } from '../grn/grn.entity';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';



let moment = require('moment')


@Injectable()
export class AsnService {
  constructor(
    @InjectRepository(Asn)
    private asnRepository: Repository<Asn>,
    @InjectRepository(AsnItems)
    private asnItemsRepository: Repository<AsnItems>,
    private asnAdapter: AsnAdapter,
    private AsnRepo: AsnRepository,
    @InjectRepository(PoCreation)
    private poRepo: Repository<PoCreation>,
    @InjectRepository(PoItems)
    private poItemsRepo: Repository<PoItems>,
    private wtsAppBroadCatService: WhatsAppNotificationService,
    private whatsappservice:WhatsappBroadCastService,

    @InjectRepository(Grn)
    private grnEntity: Repository<Grn>



  ) { }

  async getVendorDataforVendorId(vendorId: number) {
    const manager = getManager()
    const vendorCode = await manager.query(`select vendor_code as vendorCode,vendor_name as vendorName from ` + appSettings.masters_db + `.vendors where vendor_id = ` + vendorId + ` LIMIT 1`)
    return vendorCode[0].vendorName
  }


  async createAsn(values: AsnDto): Promise<CommonResponse> {
    const transaction = new GenericTransactionManager
    try {
      let poStatus: PackingSupplierStatusEnum
      let findForPartialAsn
      const manager = getManager()
      const partialAsnFlag = new Set()
      const vendorCode = await manager.query(`select vendor_code as vendorCode,vendor_name as vendorName from ` + appSettings.masters_db + `.vendors where vendor_id = ` + values.vendorId + ` LIMIT 1`)
      const slNo = await this.AsnRepo.count()
      let asnNumber = ( "ASN/00" + slNo)
      values.asnNumber = asnNumber
      const message = `\n*PO*:` + values.poNum + `\n *VENDOR*:` + vendorCode[0].vendorName + `\n`
      await transaction.startTransaction()
      const saveData = await transaction.getRepository(Asn).save(values)
      let updatePoStatus
      const poMap = new Map<number, any | undefined>()
      for (const element of saveData.asnItemsInfo) {
        // updating supplier status in PO Table
        if (poMap.has(element.poId)) {
          const newData = poMap.get(element.poId)
          newData?.push(element)
          poMap.set(element.poId, newData)
        } else {
          poMap.set(element.poId, [element])
        }
      }
      for (const po of poMap.keys()) {
        for (const poItem of poMap.get(po)) {
          const updatePo = await transaction.getRepository(PoItems).update({ purchaseOrderId: poItem.poId, itemName: poItem.itemId }, { asnQty: () => `asn_qty + ${poItem.asnQuantity}` })
          if (updatePo) {
            findForPartialAsn = await transaction.getRepository(PoItems).find({ where: { purchaseOrderId: poItem.poId, itemQuantity: Raw(alias => `item_quantity > asn_qty`) } })
            // console.log(findForPartialAsn,'findForPartialAsn')
            if (findForPartialAsn.length) {
              partialAsnFlag.add(true)
            }
          }
        }
        updatePoStatus = await transaction.getRepository(PoCreation).update({ purchaseOrderId: po }, { supplierStatus: partialAsnFlag.has(true) ? PackingSupplierStatusEnum.PARTIAL_ASN : PackingSupplierStatusEnum.ASN })
      }
      if (updatePoStatus) {
        const parameters = [
          {
            "type": "text", "text": ` Update from *${vendorCode[0].vendorName}* \\n Your Shipment with order no ${values.poNum} is on its way! \\n
          ORDER SUMMARY : \\n
          Order Date: [date] ` },
        ]
        for (const contact of whatsApp.contacts) {
          let statusflag = true
          const req = await new MessageParameters(contact, 'supplier_portal', parameters, "en_us")
          const messageStatus = await this.wtsAppBroadCatService.sendMessageThroughFbApi(req);
          if(!messageStatus.status){
            statusflag =false;
          }else{
            statusflag =true;
            // const whatsapplogDto = new WhatsAppLogDto(contact,'supplier_portal','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.supplierPortaModuleId)
            // await this.whatsappservice.createWhatappLog(whatsapplogDto)
          
          }
        }
        await transaction.completeTransaction()
        return new CommonResponse(true, 11111, 'ASN is Created Sucessfully',saveData)
      } else {
        await transaction.releaseTransaction()
        return new CommonResponse(false, 11111, 'Something went wrong')
      }
    } catch (error) {
      await transaction.releaseTransaction()
      console.log(error, '--------')
      return new CommonResponse(false, 11111, 'Error Occured')
    }

  }

  async getAsnListForVendor(req: VenndorIdReq): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const query = `select a.asn_id as asnId,a.file_name as fileName,a.asn_number as asnNumber,a.asn_date as asnDate,a.shipment_no as shipmentNumber,a.eway_bill_no as eWayBillNo,a.dc_number as dcNumber,GROUP_CONCAT(DISTINCT(po_number)) as poNumber,a.vehicle_no as vehicleNo,a.driver_name as driverName,a.driver_ph_no as driverPhNo from ` + appSettings.procure_db + `.asn a 
      left join ` + appSettings.procure_db + `.asn_items ai on ai.asn_id = a.asn_id
      left join ` + appSettings.procure_db + `.purchase_order po on po.purchase_order_id = ai.po_id where a.vendor_id = ` + req.vendorId + ` group by ai.asn_id`
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'Error Occured')
      }
    } catch {
      return new CommonResponse(false, 11111, 'Something went wrong')
    }
  }

  async getAsnItemsListForAsn(req: AsnIdReq): Promise<CommonResponse> {
    try {
      const manager = getManager();
      const query = `select ai.asn_item_id as asnItemId,ai.item_id as itemId,i.item_name as itemName,ai.asn_quantity as asnQuantity,ai.po_quantity as poQuantity,vp.unit_price as unitPrice from ` + appSettings.procure_db + `.asn_items ai 
      left join ` + appSettings.procure_db + `.asn a on a.asn_id = ai.asn_id
      left join ` + appSettings.masters_db + `.items i on i.item_id = ai.item_id
      left join ` + appSettings.masters_db + `.vendor_price_list vp on vp.item_id = ai.item_id
      where ai.asn_id = ` + req.asnId
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'No Data Found')
      }
    } catch {
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async getAllAsnData(req: AsnIdReq): Promise<CommonResponse> {
    try {

      const asnData = await this.asnRepository.find({ where: { asnId: req.asnId }, relations: ['asnItemsInfo'] })
      if (asnData.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', asnData)
      } else {
        return new CommonResponse(false, 11111, 'No Data Found')
      }
    } catch (err) {
      console.log(err)
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async getAsnListforInvoice(req: VenndorIdReq): Promise<CommonResponse> {
    try {
      const data = await this.asnRepository.find({ where: { vendorId: req.vendorId }, select: ['asnId', 'asnNumber'] })
      if (data && data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'No Data Found')
      }
    } catch (err) {
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async createInvoice(req: InvoiceCreateDto): Promise<CommonResponse> {
    try {
      const updateAsnData = await this.asnRepository.update({ asnId: req.asnId }, { invoiceDate: req.invoiceData, invoiceNumber: req.invoceNumber, asnStatus: PackingSupplierStatusEnum.OPEN })
      const asnData = await this.asnRepository.find({ select: ['asnNumber', 'vendorId'], where: { asnId: req.asnId } })
      const vendorCode = await this.getVendorDataforVendorId(asnData[0].vendorId)

      if (updateAsnData.affected) {
        const message = `\n Invoice has been generated against \n*ASN Number*:` + asnData[0].asnNumber + `\n *VENDOR*:` + vendorCode + `\n`
        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(17,message,['917036045967']));
      }

      if (updateAsnData.affected) {
        return new CommonResponse(true, 1111, 'Updated sucessfully')
      } else {
        return new CommonResponse(false, 1111, 'Failed to Update')
      }

    } catch {
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async createPayment(req: PaymentCreateDto): Promise<CommonResponse> {
    const transaction = new GenericTransactionManager
    try {
      const updateAsnData = await this.asnRepository.update({ asnId: req.asnId }, { paymentDate: req.paymentDate, paymentType: req.paymentType, asnStatus: PackingSupplierStatusEnum.OPEN, receivedAmount: req.receivedAmount })
      const asnData = await this.asnRepository.find({ select: ['asnNumber', 'vendorId'], where: { asnId: req.asnId } })
      const vendorCode = await this.getVendorDataforVendorId(asnData[0].vendorId)
      if (updateAsnData.affected) {
        const message = `\n Payment has been done against \n*ASN Number*:` + asnData[0].asnNumber + `\n *VENDOR*:` + vendorCode + `\n`
        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(18,message,['917036045967']));
        return new CommonResponse(true, 1111, 'Updated sucessfully')
      } else {
        return new CommonResponse(false, 1111, 'Failed to Update')
      }
    } catch (error) {
      console.log(error)
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async getinvoiceListForVendor(req: VenndorIdReq): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const query = `select a.asn_id as asnId,a.asn_number as asnNumber,a.asn_date as asnDate,a.shipment_no as shipmentNumber,a.eway_bill_no as eWayBillNo,a.dc_number as dcNumber,po.po_number as poNumber,a.invoice_no as invoiceNumber,a.invoice_date as invoiceDate,a.invoice_due_date as dueDate,v.vendor_name as vendorName,v.gst_number as gstNumber,v.street as lineOne,v.apartment as lineTwo,v.city as lineThree,v.email_id as emailId from ` + appSettings.procure_db + `.asn a left join ` + appSettings.procure_db + `.purchase_order po on po.purchase_order_id = a.po_id left join ` + appSettings.masters_db + `.vendors v on v.vendor_id = a.vendor_id where a.asn_status = "INVOICE" AND a.vendor_id = ` + req.vendorId
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'Error Occured')
      }
    } catch (error) {
      console.log(error)
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async getAsnListforPayment(req: VenndorIdReq): Promise<CommonResponse> {
    try {
      const data = await this.grnEntity.find({ where: { vendorId: req.vendorId }, select: ['invoiceNumber', 'grnId'] })
      if (data && data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'No Data Found')
      }
    } catch (err) {
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async getPoStatusReport(req: VenndorIdReq): Promise<CommonResponse> {
    try {

      const manager = getManager()
      const query = `select a.asn_id as asnId,a.asn_number as asnNumber,a.asn_date as asnDate,a.shipment_no as shipmentNumber,a.eway_bill_no as eWayBillNo,a.dc_number as dcNumber,po.po_number as poNumber,a.invoice_no as invoiceNumber,a.invoice_date as invoiceDate,a.invoice_due_date as dueDate,v.vendor_name as vendorName,v.gst_number as gstNumber,v.street as lineOne,v.apartment as lineTwo,v.city as lineThree,v.email_id as emailId,a.asn_status as asnStatus,a.payment_type as paymentType,a.payment_date as paymentDate,a.received_amount as receivedAmount from ` + appSettings.procure_db + `.asn a left join ` + appSettings.procure_db + `.purchase_order po on po.purchase_order_id = a.po_id left join ` + appSettings.masters_db + `.vendors v on v.vendor_id = a.vendor_id where  a.vendor_id = ` + req.vendorId
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'Error Occured')
      }
    } catch (error) {

    }

  }

  async acknoledgeForAsn(req: AsnIdReq): Promise<CommonResponse> {
    try {

      const updateAcknowledgement = await this.asnRepository.update({ asnId: req.asnId }, { isAcknowledged: true })
      const asnData = await this.asnRepository.find({ select: ['asnNumber', 'vendorId'], where: { asnId: req.asnId } })
      const vendorCode = await this.getVendorDataforVendorId(asnData[0].vendorId)
      if (updateAcknowledgement.affected) {
        const message = `\n Payment has been done against \n*ASN Number*:` + asnData[0].asnNumber + `\n *VENDOR*:` + vendorCode + `\n`
        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(18,message,['917036045967']));

        return new CommonResponse(true, 1111, 'Updated sucessfully')
      } else {
        return new CommonResponse(false, 1111, 'Failed to Update')
      }
    }
    catch (error) {

    }
  }

  async getPaymentsReport(req: VenndorIdReq): Promise<CommonResponse> {
    try {

      const manager = getManager()
      const query = `select a.asn_id as asnId,a.asn_number as asnNumber,a.asn_date as asnDate,a.shipment_no as shipmentNumber,a.eway_bill_no as eWayBillNo,a.dc_number as dcNumber,po.po_number as poNumber,a.invoice_no as invoiceNumber,a.invoice_date as invoiceDate,a.invoice_due_date as dueDate,a.asn_status as asnStatus,a.payment_type as paymentType,a.payment_date as paymentDate,a.received_amount as receivedAmount from ` + appSettings.procure_db + `.asn a left join ` + appSettings.procure_db + `.purchase_order po on po.purchase_order_id = a.po_id left join ` + appSettings.masters_db + `.vendors v on v.vendor_id = a.vendor_id where  a.vendor_id = ` + req.vendorId
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'Error Occured')
      }
    } catch (error) {

    }

  }

  async getAllAsnDropdownData(): Promise<CommonResponse> {
    try {
      const data = await this.asnRepository.find({ where: { asnStatus: 'INVOICE' }, select: ['asnId', 'asnNumber'] })
      if (data && data.length > 0) {
        return new CommonResponse(true, 1111, 'Data retrived sucessfully', data)
      } else {
        return new CommonResponse(false, 11111, 'No Data Found')
      }
    } catch (err) {
      return new CommonResponse(false, 11111, 'Error Occured')
    }
  }

  async getMessageResponse(mesRes : any){
    console.log(mesRes)
  }
  async acknowledgeForPo(req: any): Promise<CommonResponse> {
    const manager =getManager();
    const update = await this.poRepo.update({ purchaseOrderId: req.purchaseOrderId }, { isAcknowledged: true, vendorAckDate: req.date });
    const parameters = [
      { "type": "text", "text": ` Acknowledgement by *${req.supplierName}* \\n We would like to take this opportunity to thank you for your recent order, placed on ${req.poDate}, order number ${req.poNumber}. \\n Your order is being processed and will be shipped out to you by ${req.acknowledgedDate} ${req.remarks ? ("\\n Additional note :" + req.remarks) : ""}` },
    ]
    for (const contact of whatsApp.contacts) {
     let statusFlag = true;
      const req = await new MessageParameters(contact, 'supplier_portal', parameters, "en_us")
      const messageStatus = await this.wtsAppBroadCatService.sendMessageThroughFbApi(req);
      if (!messageStatus.status) {
        statusFlag = false
      }else{
        statusFlag = true

        const whatsapplogDto = new WhatsAppLogDto(contact,'supplier_portal','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.supplierPortaModuleId)
              await this.whatsappservice.createWhatappLog(whatsapplogDto)
      }
    }
    return new CommonResponse(true, 1111, "Acknowledged Sucessfully")
  }

  async getPoNumbersAndPoItems(req: any): Promise<CommonResponse> {
    const manager = getManager()
    const query = `select po.po_number as poNumber,po.purchase_order_id as purchaseOrderId,(select poi.purchase_order_items_id as purchaseOrderItemId,poi.item_name as itemId,i.item_name as itemName from ${appSettings.procure_db}.purchase_order_items poi left join ${appSettings.masters_db}.items i on i.item_id = poi.item_name where poi.purchase_order_id = po.purchase_order_id) as poItems from ${appSettings.procure_db}.purchase_order po where po.vendor_id = ${req.vendorId}`
    const data = await manager.query(query)
    if (data && data.length) {
      return new CommonResponse(true, 1111, "Data retreived sucessfully")
    } else {
      return new CommonResponse(false, 1111, "No data found")
    }
  }

  async getPoItemsForPoNumber(req: any): Promise<CommonResponse> {
    const manager = getManager()
    const query = `select poi.purchase_order_items_id as purchaseOrderItemId,poi.item_name as itemId,i.item_name as itemName,poi.item_quantity as quantity,poi.asn_qty as asnQty from ${appSettings.procure_db}.purchase_order_items poi left join ${appSettings.masters_db}.items i on i.item_id = poi.item_name where poi.purchase_order_id = ${req.purchaseOrderId} and poi.asn_qty < poi.item_quantity`
    const data = await manager.query(query)
    if (data && data.length) {
      return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
    } else {
      return new CommonResponse(false, 1111, "No data found")
    }
  }
  async asnFileUpload(filePath: string,filename:string,asnId: number): Promise<FileUploadResponse> {
    
    try{
        const filePathUpdate = await this.AsnRepo.update(
            { asnId: asnId },
            { filePath: filePath ,fileName:filename},
           
          );
          if (filePathUpdate.affected > 0) {
            return new FileUploadResponse( true, 11, 'uploaded successfully',filePath);
            
          }
          else{
            return new FileUploadResponse( false, 11, 'uploaded failed',filePath);
          }
    }
    catch(error){   
        console.log(error); 
    }
  }
// async asnFileUpload(filePath: string,filename:string,asnId: number): Promise<FileUploadResponse> {
//   const manager = getManager()
//   const query = ``
//   const data = await manager.query(query)
//   if (data && data.length) {
//     return new FileUploadResponse(true, 11, 'uploaded successfully', data)
//   } else {
//     return new FileUploadResponse(false, 11, 'uploaded failed',data)
//   }
    
      
// }
}






